export default __webpack_public_path__ + "static/media/testimon2.944a6c63.mp4";